import { makeStyles, tokens } from '@coreai/fluentui-react';

export const useAppShellStyles = makeStyles({
  body: {
    display: 'flex',
    flexDirection: 'row',
    flex: '1 1 0%',
    minHeight: 0,
    overflow: 'hidden',
    gap: tokens.spacingHorizontalXXS,
    backgroundColor: tokens.colorNeutralBackground4,
  },
  main: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 0%',
    minWidth: 0,
    minHeight: 0,
    backgroundColor: tokens.colorNeutralBackground1,
    boxShadow: tokens.shadow2,
    borderTopLeftRadius: tokens.borderRadius2XLarge,
  },
});
